import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ResponsiveWorks = (props) => {
  const { t } = useTranslation();
  const [OpenMedia, setOpenMedia] = useState(false);
  const [openeducation, setOpenEducation] = useState(false);
  const [openWeb, setOpenWeb] = useState(false);
  const [openDigital, setOpenDigital] = useState(false);

  return (
    <div className="ResponsiveWorks">
        <NavLink onClick={()=>props.setFilter(prev=>!prev)} className='link1' to="all">{t("All")}</NavLink>

      <button onClick={() => {
        
        setOpenMedia((prev) => !prev)}} className="link1">
        {t("Media Production")}
      </button>
      <div
        className="services-list m-0 flex flex-col justify-start items-start gap-[6px] overflow-hidden transition-all duration-500 ease-in-out"
        style={{ height: OpenMedia ? "122px" : "0px" }}
      >
        <NavLink
          onClick={() => {
            setOpenMedia((prev) => !prev);
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="renting-studios"
        >
          {t("Renting Company Studios")}
        </NavLink>
        <NavLink
          onClick={() => {
            setOpenMedia((prev) => !prev);
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="post-production"
        >
          {t("Post Production")}
        </NavLink>
        <NavLink
          onClick={() => {
            setOpenMedia((prev) => !prev);
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="Photography"
        >
          {t("Photography")}
        </NavLink>

        <NavLink
          onClick={() => {
            setOpenMedia((prev) => !prev);
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="videography"
        >
          {t("Videography")}
        </NavLink>
      </div>
      <button onClick={() => {
        
        setOpenEducation((prev) => !prev)}} className="link1">
        {t("Education Services")}
      </button>
      <div
        className="services-list m-0 flex flex-col justify-start items-start gap-[6px] overflow-hidden transition-all duration-500 ease-in-out"
        style={{ height: openeducation ? "172px" : "0px" }}
      >
        <NavLink
          onClick={() => {
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="tranning-platforms"
        >
          {t("Management of training platforms")}
        </NavLink>
        <NavLink
          onClick={() => {
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="tranning-bags"
        >
          {t("Preparing training bags")}
        </NavLink>
        <NavLink
          onClick={() => {
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="electronic-marketing"
        >
          {t("Electronic marketing")}
        </NavLink>

        <NavLink
          onClick={() => {
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="tranning-content"
        >
          {t("Register training content")}
        </NavLink>
        <NavLink
          onClick={() => {
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="project-management"
        >
          {t("Project management")}
        </NavLink>
        <NavLink
          onClick={() => {
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="virtual-project"
        >
          {t("Virtual projects")}
        </NavLink>
      </div>


      <button onClick={() => setOpenWeb((prev) => !prev)} className="link1">
        {t("Web Solution")}
      </button>
      <div
        className="services-list m-0 flex flex-col justify-start items-start gap-[6px] overflow-hidden transition-all duration-500 ease-in-out"
        style={{ height: openWeb ? "50px" : "0px" }}
      >
        <NavLink
          onClick={() => {
            setOpenWeb((prev) => !prev);
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="web-design"
        >
          {t("Web Design")}
        </NavLink>
        <NavLink
          onClick={() => {
            setOpenWeb((prev) => !prev);
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="development"
        >
          {t("Web Development")}
        </NavLink>
      
      </div>
      <button onClick={() => setOpenDigital((prev) => !prev)} className="link1">
        {t("Digital Marketing")}
      </button>
      <div
        className="services-list m-0 flex flex-col justify-start items-start gap-[6px] overflow-hidden transition-all duration-500 ease-in-out"
        style={{ height: openDigital ? "55px" : "0px" }}
      >
        <NavLink
          onClick={() => {
            setOpenDigital((prev) => !prev);
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="social-media"
        >
          {t("Social media")}
        </NavLink>
        <NavLink
          onClick={() => {
            setOpenDigital((prev) => !prev);
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="media-buying"
        >
          {t("Media buying")}
        </NavLink>
      
      </div>
      <button onClick={() => setOpenDigital((prev) => !prev)} className="link1">
        {t("Event Management")}
      </button>
      <div
        className="services-list m-0 flex flex-col justify-start items-start gap-[6px] overflow-hidden transition-all duration-500 ease-in-out"
        style={{ height: openDigital ? "70px" : "0px" }}
      >
        <NavLink
          onClick={() => {
            setOpenDigital((prev) => !prev);
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="Implementation"
        >
          {t("Implementation of conference-related work")}
        </NavLink>
        <NavLink
          onClick={() => {
            setOpenDigital((prev) => !prev);
            props.setFilter(prev=>!prev)
          }}
          className="link"
          to="Conference"
        >
          {t("Conference management and organization")}
        </NavLink>
      
      </div>
    </div>
  );
};

export default ResponsiveWorks;